
<template>
  <div>
    <dialog-loading v-if="loading"></dialog-loading>
    <dialog-create-task v-if="!loading && task" :task="task" is_edit :is_new="false" @cancel="handleCancel" @done="handleDone"></dialog-create-task>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';
import DialogCreateTask from '../../components/tasks/control/DialogCreateTask.vue';

export default {
  name: 'ShowTaskPage',
  //mixins: [ validations ],
  components: {
    DialogCreateTask
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      task: null,
    }
  },
  methods: {
    showTask() {
      this.loading= true
      Api.Task.show(this.$route.params.id).then(r=>r.data).then(d=> {
        this.task = {...d}
      }).catch(err=> {
        console.log({err});
        this.$router.go(-1)
      }).finally(()=>{
        this.loading = false
      })
    },
    handleCancel() {
      this.$router.go(-1)
    },
    handleDone(){
      this.$router.go(-1)
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.showTask();
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>